export const fetchUsersSelectors = {
    byId: (arg, result) => ({
        ...result,
        data: result?.data?.find(user => user.id === arg.id),
    }),
}
